import I18n from 'I18n';
import { useEffect, useState } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { getFeature } from 'purchase-motions-api/query/featureStore';
import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
import { getSupportUrl } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ActivationSuccessModal = ({
  apiName,
  onStartSuccess,
  upgradeConfig
}) => {
  var _featureData$feature2;
  const productLine = apiName.split('-')[0];
  const [featureData, setFeatureData] = useState({
    feature: undefined,
    fetched: false
  });
  useEffect(() => {
    if (upgradeConfig !== null && upgradeConfig !== void 0 && upgradeConfig.featureStoreFeature) {
      getFeature({
        shortName: upgradeConfig.featureStoreFeature
      }).then(feature => {
        setFeatureData({
          feature,
          fetched: true
        });
      }).catch(() => {
        setFeatureData({
          feature: undefined,
          fetched: true
        });
      });
    } else {
      setFeatureData({
        feature: undefined,
        fetched: true
      });
    }
  }, [upgradeConfig === null || upgradeConfig === void 0 ? void 0 : upgradeConfig.featureStoreFeature]);
  if (!featureData.fetched) {
    return null;
  }
  const renderDialogBodyContent = () => apiName === CRM_SUITE_STARTER_BUNDLE ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.activationModal.suiteStarterContent.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.activationModal.suiteStarterContent.subtitle"
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Text, {
      as: "p",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "purchaseMotions.trial.activationModal.suiteStarterContent.footer_jsx",
        elements: {
          Link
        },
        options: {
          linkProps: {
            href: getSupportUrl()
          }
        }
      })
    })]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.trial.activationModal.globalContentBlock.title"
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "200",
      children: /*#__PURE__*/_jsxs(List, {
        styled: true,
        marginBlockEnd: "400",
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.activationModal.globalContentBlock.tryForFree",
            options: {
              productName: I18n.text(`purchaseMotions.products.${apiName}`)
            }
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.activationModal.globalContentBlock.getSupport"
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.activationModal.globalContentBlock.browseHowTo"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: `purchaseMotions.trial.activationModal.dynamicContentBlock.${productLine}`
    })]
  });
  const renderDialogFooterButton = () => {
    var _featureData$feature;
    return apiName === CRM_SUITE_STARTER_BUNDLE ? /*#__PURE__*/_jsx(Button, {
      block: true,
      use: "primary",
      onClick: onStartSuccess,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.activationModal.suiteStarterContent.button"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [featureData !== null && featureData !== void 0 && (_featureData$feature = featureData.feature) !== null && _featureData$feature !== void 0 && _featureData$feature.displayName ? /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "purchaseMotions.trial.activationModal.headBackToFeature",
          options: {
            featureName: featureData.feature.displayName
          }
        })
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.activationModal.trialStartSubtitle"
      }), /*#__PURE__*/_jsx(Button, {
        block: true,
        use: "primary",
        onClick: onStartSuccess,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.trial.activationModal.startSetup"
        })
      })]
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    size: "auto",
    use: "success",
    width: 600,
    "data-test-id": "activation-success-modal",
    children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetTop: 40,
      offsetBottom: -30,
      children: /*#__PURE__*/_jsx(Illustration, {
        name: featureData !== null && featureData !== void 0 && (_featureData$feature2 = featureData.feature) !== null && _featureData$feature2 !== void 0 && _featureData$feature2.displayName ? 'errors/map' : 'success',
        width: 118
      })
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: 'purchaseMotions.trial.activationModal.trialStartTitle'
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        justifyContent: "start",
        children: renderDialogBodyContent()
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "300",
        maxInlineSize: "450px",
        children: renderDialogFooterButton()
      })
    })]
  });
};